import React from 'react';
import Sidebar from './sidebar';
import FooterStyle from './footer';
import { Link } from 'react-router-dom';
import { CertificateCard, PreviewCard } from './propertycard';


export const CertificationPage = () => {
  return (
    <div className='top-layout'>
      <div className='Navbar'>
        <Sidebar />
      </div>
    
      <div className='layout'>

        <div className='KS-logo'>
          <Link to="/" style={{ position:'absolute', cursor: 'pointer', zIndex: '100'}}>
            <img src={process.env.PUBLIC_URL + '/images/KS_logo.png'} alt="Logo" style={{ width: '4.5rem', marginTop:'0.3rem'}} />
          </Link>
        </div>

        <div className='backgroundImage'>
          <img src={process.env.PUBLIC_URL + '/images/EVENTS/DSCF0615.JPG'} alt="headImage" style={{ width: '100%', position:'relative', top:'7rem' }} />  
          <h1>CERTIFICATIONS</h1>
        </div>


        <div className='certifications-content'>

              <div className='certificate-card'>
                <CertificateCard
                  imageUrl={process.env.PUBLIC_URL + '/images/AWARDS/Anugerah-KPKPR2020.jpg'}
                  title={'Anugerah Pengurusan Dan Penyenggaraan Terbaik Bangunan Gunasama Perseketuan Tahun 2020.'}
                  style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
                />
                <CertificateCard 
                  imageUrl={process.env.PUBLIC_URL + '/images/AWARDS/Anugerah-KPKPR2022.jpg'}
                  title={'Anugerah Pengurusan Dan Penyenggaraan Terbaik Bangunan Gunasama Perseketuan Tahun 2022.'}
                  style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
                />
              </div>
              <div className='coming-soon'>
                <h3>To be updated. .</h3>
              </div>
              {/* <div className='coming-soon'>
                <PreviewCard/>
              </div> */}
        </div>


        <div className='footer'>
          <FooterStyle />
        </div>

      </div>

      

    </div>
  );
}

export default CertificationPage;
